import styled from "styled-components"

export const FeatureImageWrapper = styled.div`
  grid-column: 2 / -2;
  height: 600px;
  overflow: hidden;
  position: relative;
  `